import ViewFactory from "../helpers/viewfactory";
import EventLog from "../../../logger/events";
import Mixpanel from "../../../init/mixpanel";
import ErrorState from "../../common/error";
import getChargeData from "../../../init/chargedata";
import { traverseDataFields } from "../../../charge/handler/helpers";
import { getValueAtPath, isPlainObject } from "../../../utils";
import { parentWindow, hasParent, isWindowOpen } from "../../../init/window";
import { getParams } from "../../../init/searchparams";
import Supports from "../../../utils/supports";

export default function view() {
  const $this = isPlainObject(this) ? this : Object.create(null);

  return ViewFactory({
    NAME: 'SUCCESS_VIEW',
    
    mount() {
      // Ensure that any error message is cleared when success view loads
      $this.dispatch(ErrorState.actions.updateErrorMessage());

      const paymentMethod = getValueAtPath($this, 'STATE.method.current');

      if (Supports.localStorage && paymentMethod) {
        localStorage.setItem('lastUsedOption', paymentMethod);
      }

      const { $$data: data1, data: data2 } = this;
      const $data = isPlainObject(data1) ? data1 : isPlainObject(data2) ? data2 : null;
      const $isVBV = getValueAtPath($data, 'name') === 'vbvcomplete';

      const $tx = (
        $isVBV
          ? traverseDataFields($data, 'transactionobject').transactionobject
          : traverseDataFields($data, 'tx').tx || traverseDataFields($data, 'data').data || $data
      ) || null;

      EventLog.transactionSuccessful();
      Supports.localStorage ? localStorage.removeItem('retryAttempts') : void 0;

      (cb => (Mixpanel.mixpanelInitialized()
        ? Mixpanel.completedPayment().finally(() => cb())
        : Promise.resolve().then(() => cb())
      ))(() => {
        if (hasParent || isWindowOpen) {
          try {
            parentWindow.postMessage({
              name: $data.name || 'opop',
              data: $data,
              tx: $tx,
              success: true
            }, '*');
            return;
          } catch (e) {}
        }

        setTimeout(function() {
          getChargeData().then($chargedata => {
            try {
              const red_url = getValueAtPath($chargedata, 'redirect_url');
              const tx_ref = getValueAtPath($chargedata, 'txref');

              if (red_url && tx_ref) {
                const redirect = new URL(red_url);
                const redirectParams = redirect.searchParams;

                if ($chargedata.use_v3 === true) {
                  const { transaction_id, status } = traverseDataFields($tx, 'id::transaction_id', 'status');

                  redirectParams.set('status', status || 'failed');
                  redirectParams.set('tx_ref', tx_ref);
                  redirectParams.set('transaction_id', transaction_id);

                  EventLog.redirectingToMerchant($tx)
                    .finally(() => window.location.href = redirect.href);
                } else {
                  const {
                    redirect_post,
                    redirect_no_json
                  } = getParams('redirect_post', 'redirect_no_json');

                  const method = +redirect_post ? 'POST' : 'GET';

                  if (method === 'GET' && +redirect_no_json) {
                      EventLog.redirectingToMerchant($tx)
                      .finally(() => window.location.href = redirect.href);
                      return;
                  }

                  const $form = document.createElement('form');
                  const $textarea = document.createElement('textarea');

                  $textarea.setAttribute('name', 'resp');
                  $textarea.setAttribute('hidden', 'hidden');
                  $textarea.setAttribute('readonly', 'readonly');
                  $textarea.classList.add('sr-only');

                  $textarea.value = JSON.stringify($data);

                  $form.setAttribute('method', method);
                  $form.setAttribute('action', redirect.href);
                  $form.setAttribute('hidden', 'hidden');
                  $form.classList.add('sr-only');

                  $form.appendChild($textarea);
                  document.body.appendChild($form);

                  EventLog.redirectingToMerchant($tx)
                    .finally(() => $form.submit());
                }
              }
            } catch (e) {}
          });
        }, 5000);
      });
    }
  }).call(this);
}
